<template>
    <div class="container-xxl">
        <div class="dropdown-100-menu py-lg-4 extended-wrapper row">
            <div class="col-9">
                <div class="row g-4 mt-3 d-flex align-items-end">
                    <div
                        v-for="section in content.children"
                        :key="section.title"
                        :class="colClass(section)"
                        class="mt-2 menu-section"
                    >
                        <NuxtLink
                            v-if="section.link"
                            :to="section.link"
                            @click="handleClick"
                            class="section-title"
                        >{{ section.title }}</NuxtLink>
                        <span v-else class="section-title">{{ section.title }}</span>
                        <div
                            class="row g-3"
                            v-if="section.children?.length"
                        >
                            <div
                                v-for="(colItems, ci) in getColumns(section.children)"
                                :key="ci"
                                class="col mb-2"
                            >
                                <NuxtLink
                                    v-for="item in colItems"
                                    :key="item.title"
                                    class="d-block"
                                    :to="item.link"
                                    @click="handleClick"
                                >
                                    {{ item.title }}
                                </NuxtLink>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="content.code === 'learn'" class="row">
                    <div
                        v-for="(colItems, ci) in getColumns(menuStore.blogItems)"
                        :key="ci"
                        class="col mb-2 menu-section"
                    >
                        <NuxtLink
                            :to="localePath({name: 'blog'})"
                            class="section-title text-uppercase"
                        >{{ $t('blog.popular_reads') }}</NuxtLink>
                        <ExtendedBlogSection :items="colItems" @click="$emit('toggle-dropdown')"/>
                    </div>
                </div>
            </div>

            <div class="col-3 d-flex justify-content-center mt-4">
                <ProductThumbVip :code="content.vip_code"/>
            </div>

        </div>
    </div>
</template>

<script setup>
const ProductThumbVip = defineAsyncComponent(() => import("~/components/Product/Thumbs/ProductThumbVip.vue"));
const ExtendedBlogSection = defineAsyncComponent(() => import("~/components/Menu/ExtendedBlogSection.vue"));

import { useLocalePath } from '#imports';

const localePath = useLocalePath();

const emit = defineEmits(['toggle-dropdown'])
const props = defineProps({
    content: {
        type: Object,
        default: () => ({ children: [] })
    }
})

const menuStore = useMenuStore();

const handleClick = () => emit('toggle-dropdown')

const colClass = (section) => {
    if (section.blog) {
        return 'col-lg-12';
    }
    const len = section.children?.length || 0
    if (len > 15) return 'col-lg-12'
    if (len > 10) return 'col-lg-9'
    if (len > 5)  return 'col-lg-6'
    return 'col-lg-3'
}

const getColumns = (children) => {
    const items = children || []
    const len = items.length
    const per = 5
    const cols = Math.min(4, Math.ceil(len / per))

    const result = []
    for (let i = 0; i < cols; i++) {
        result.push(items.slice(i * per, (i + 1) * per))
    }
    return result
}
</script>

<style scoped>
.section-title {
    display: block;
    width: 100%;
    padding-bottom: 0.25rem;
    margin-bottom: 1.25rem;
    border-bottom: 1px solid #ccc;
    font-size: 1rem;
    font-weight: 500;
}

.child-grid {
    display: flex;
    column-gap: 1.5rem;
}

.col {
    flex: 1;
}

.d-block {
    margin-bottom: 0.50rem;
    white-space: nowrap;
    line-height: 1rem;
}
</style>
